import React, { MouseEvent } from 'react';
import { TablePagination, Table } from '@mui/material';
import { TABLE } from '../../../consts';
import { Scrollbar } from '../../Scrollbar';
import style from './style';

type TableContainerType = {
  children: JSX.Element | JSX.Element[];
  onPageChange: (event: MouseEvent<HTMLButtonElement> | null, newPage: number) => void;
  page: number;
  totalCount: number;
  isLoading: boolean;
  paginationType?: string,
  hasNextPage?: boolean,
}

const PAGINATION_TYPE = {
  TOTAL_COUNT: 'TOTAL_COUNT', // show counter of pages
  NEXT_PAGE: 'NEXT_PAGE', // unknown number of pages, pointer-indexed-list
};

const TableContainer = ({
  children,
  onPageChange,
  page,
  totalCount,
  isLoading,
  paginationType = undefined,
  hasNextPage = undefined,
}: TableContainerType): JSX.Element => {
  const showCustomPagination = paginationType === PAGINATION_TYPE.NEXT_PAGE;

  const customLabelDisplayedRows = (/* { from, to, count } */) => {
    switch (paginationType) {
      default:
      case PAGINATION_TYPE.NEXT_PAGE: {
        // remove page/counter label for next-page list type
        return '';
      }
    }
  };

  const customNextButtonProps = () => {
    switch (paginationType) {
      default:
      case PAGINATION_TYPE.NEXT_PAGE: {
        return {
          disabled: !hasNextPage,
        };
      }
    }
  };

  return (
    <>
      <Scrollbar>
        <Table sx={
          isLoading ?
            { ...style.table.sx, ...style.table.loading } :
            { ...style.table.sx }
        }
        >
          { children }
        </Table>
      </Scrollbar>
      <TablePagination
        labelDisplayedRows={
          showCustomPagination ?
            customLabelDisplayedRows :
            undefined // dont change default label - show "1-10 of 200"
        }
        nextIconButtonProps={
          showCustomPagination ?
            customNextButtonProps() :
            undefined // show default next icon with its default properties
        }
        component={ style.pagination.component }
        count={ totalCount }
        onPageChange={ onPageChange }
        page={ page }
        rowsPerPage={ TABLE.ROWS_PER_PAGE }
        rowsPerPageOptions={ TABLE.ROWS_PER_PAGE_OPT }
      />
    </>
  );
};
TableContainer.defaultProps = {
  paginationType: undefined,
  hasNextPage: undefined,
};

export default TableContainer;
